export default __webpack_public_path__ + "static/media/CarterOne-Regular.077c4bbc.ttf";